import { Injectable } from '@angular/core';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { RetailStoreConstants } from '../retail_api/constants/retailHq.constants';
import { map } from 'rxjs/internal/operators/map';
import { ActiveUserConstants } from '../activeusers_api/constatnts/activeusers.constant';
import { GlobalConstants } from 'src/app/common/constants/global.constant';

@Injectable({
  providedIn: 'root'
})
export class RetailService {

  userId = sessionStorage.getItem('userId');
  loginUserRole = sessionStorage.getItem('userRole');
  RETAILEHQ_URL = RetailStoreConstants.SLASH_RETAILER_STORE + RetailStoreConstants.SLASH_RETAILER
    + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH + this.userId +
    RetailStoreConstants.RETAILER_URL;
  UPDATE_URL = RetailStoreConstants.SLASH_RETAILER_STORE + RetailStoreConstants.SLASH_RETAILER + RetailStoreConstants.SLASH_USER_ID
    + RetailStoreConstants.SLASH + this.userId + RetailStoreConstants.RETAILER_URL + RetailStoreConstants.SLASH;
  constructor(
    private httpMethod: HttpMethodsService) { }

  getAllRetailerInfo(sortby: string, sorttype: string) {
    const url = RetailStoreConstants.SLASH_RETAILER_STORE + RetailStoreConstants.SLASH_RETAILER
      + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH + sessionStorage.getItem('userId') +
      RetailStoreConstants.RETAILER_URL + RetailStoreConstants.SORTBY + sortby + RetailStoreConstants.SORT_TYPE + sorttype;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getUnconnectedRetailer() {
    const url = RetailStoreConstants.SLASH_RETAILER_STORE + RetailStoreConstants.SLASH_RETAILER
      + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH + sessionStorage.getItem('userId') +
      RetailStoreConstants.RETAILER_URL + RetailStoreConstants.SLASH + GlobalConstants.UNCONNECTED_ID;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllRetailerInfoById(id: string, filterString?: string) {
    let url = RetailStoreConstants.SLASH_RETAILER_STORE + RetailStoreConstants.SLASH_RETAILER
      + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH + sessionStorage.getItem('userId') +
      RetailStoreConstants.RETAILER_URL + RetailStoreConstants.SLASH + id;
    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllRetailerInfoSearchByName(name: string, pageNumber: number) {
    const url = this.RETAILEHQ_URL + RetailStoreConstants.SEARCH_URL + name + RetailStoreConstants.PAGE_NUMBER
      + RetailStoreConstants.EQUALS + pageNumber;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllRetailerInfoSortBy(id: string, pageNumber: number, filterString?: string) {
    this.loginUserRole = sessionStorage.getItem('userRole');
    this.userId = sessionStorage.getItem('userId');
    this.RETAILEHQ_URL = RetailStoreConstants.SLASH_RETAILER_STORE + RetailStoreConstants.SLASH_RETAILER
      + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH + this.userId +
      RetailStoreConstants.RETAILER_URL;
    let url = (this.loginUserRole === RetailStoreConstants.RETAIL_USER_ROLE || this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE) ?
      this.RETAILEHQ_URL + RetailStoreConstants.SLASH + id : this.RETAILEHQ_URL + RetailStoreConstants.PAGE_NUMBER + RetailStoreConstants.EQUALS + pageNumber;

    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  createRetailHq(configurationsJson: string) {
    const url = this.RETAILEHQ_URL;

    return this.httpMethod.post(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  putS3CompRxtZipFile(image: File, imageType: string, retailerId: string, dataType: string) {
    const url = RetailStoreConstants.RETAILER_URL + RetailStoreConstants.SLASH + retailerId + RetailStoreConstants.SLASH + dataType;

    return this.httpMethod.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }

  putRetailHqById(configurationsJson: string, id: string) {
    const url = this.RETAILEHQ_URL + RetailStoreConstants.SLASH + id;

    return this.httpMethod.patch(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  postAllRetailerInfoforCsv(params) {
    const url = this.RETAILEHQ_URL + RetailStoreConstants.SLASH + RetailStoreConstants.DOWNLOAD;
    return this.httpMethod.postcsv(url, params)
      .pipe(map((res: any) =>
        res));
  }
  convertUserPatchCall(payload) {
    const url = RetailStoreConstants.USERMANAGEMENT + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH_CONVERT;
    return this.httpMethod.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  getDateandYear() {
    const url = RetailStoreConstants.USERMANAGEMENT + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.HOME_PAGE
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }
}
